/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts extends models.JiraServiceManagementIncidentManagementConfigurationMapping {
    getFixupPrototypeFunction() { return JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts.fixupPrototype; }

    static newInstance(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts>): JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts {
        let obj = Object.assign(new JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts(), model);
        JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts>): JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts {
        if (!model) return null;
        return JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts.newInstance(<JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts) {
        if (!obj) return;

        models.JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts): boolean {
        if (models.JiraServiceManagementIncidentManagementConfigurationMapping.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, JiraServiceManagementIncidentManagementConfigurationMappingForBudgetAlerts.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Allowed attributes for Budget Alerts Description
     */
    value: models.DescriptionAttributeForItsmBudgetAlert;

    value_direct: string;

}
